@if (areAnyGreaterThanZero()) {
  <div
    class="bg-base-100 inline-flex items-center gap-2 px-2 py-1 backdrop-blur-sm"
  >
    @for (res of resources(); track res.itemRef.id) {
      <div
        class="inline-flex items-center gap-0.5 px-1.5 py-0.5 tabular-nums whitespace-nowrap text-xs"
        (animate.enter)="onEnter($event)"
        (animate.leave)="onLeave($event)"
      >
        <app-currency-cost
          [type]="res.itemRef.id"
          [amount]="res.total"
          [animate]="true"
        />
      </div>
    }
  </div>
}
